import Vue from "vue";
import goTo from "@/core/util/goTo";

export default Vue.extend({
  methods: {
    goTo
  }
});
